"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultVariant = exports.cardVariants = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const framer_motion_1 = require("framer-motion");
const react_1 = require("react");
const useKeyPress_1 = __importDefault(require("../../hooks/useKeyPress"));
const icons_1 = require("../../icons");
const Button_1 = require("../Button");
const Container_1 = __importDefault(require("../Container"));
const Heading_1 = __importDefault(require("../Heading"));
const Portal_1 = __importDefault(require("../Portal"));
const Stack_1 = __importDefault(require("../Stack"));
const popup_module_scss_1 = __importDefault(require("./popup.module.scss"));
exports.cardVariants = ['primary', 'secondary', 'info'];
exports.defaultVariant = 'primary';
const Popup = (0, react_1.forwardRef)(({ className, title, titleIcon, id, withContentPadding = false, isOpen, withClose = true, fullScreen = false, children, variant = exports.defaultVariant, actions, onClose, }, containerRef) => {
    const ref = (0, react_1.useRef)(null);
    const escape = (0, useKeyPress_1.default)('Escape');
    (0, react_1.useEffect)(() => {
        if (escape) {
            onClose();
        }
    }, [escape, onClose]);
    useHideScrollbar(isOpen);
    return ((0, jsx_runtime_1.jsx)(Portal_1.default, { id: "popup-portal", children: (0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, { children: isOpen && ((0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, { className: (0, classnames_1.default)(popup_module_scss_1.default.popup, className), onClick: onClose, ref: ref, variants: variants.modal, children: (0, jsx_runtime_1.jsx)("div", { className: popup_module_scss_1.default.container, children: (0, jsx_runtime_1.jsxs)(framer_motion_1.motion.div, Object.assign({ className: (0, classnames_1.default)(popup_module_scss_1.default.dialog, popup_module_scss_1.default[`variant_${variant}`], fullScreen && popup_module_scss_1.default.fullScreen, withContentPadding && popup_module_scss_1.default.withPadding), variants: variants.content, transition: transitionsProps.content }, baseMotionProps, { onClick: e => e.stopPropagation(), children: [(0, jsx_runtime_1.jsxs)(Stack_1.default, { className: popup_module_scss_1.default.title, align: "center", justify: "center", layout: "horizontal", gap: "sm", children: [titleIcon, (0, jsx_runtime_1.jsx)(Heading_1.default, { as: "h3", color: variant === 'primary' ? 'grey-gray' : 'white', align: "center", fontSize: "sm", children: title }), withClose && ((0, jsx_runtime_1.jsx)(Button_1.IconButton, { icon: (0, jsx_runtime_1.jsx)(icons_1.CloseIcon, {}), label: "Close modal", size: "large", variant: variant !== exports.defaultVariant ? 'info' : 'light', onClick: onClose, className: popup_module_scss_1.default.close }))] }), (0, jsx_runtime_1.jsx)("div", { className: popup_module_scss_1.default.content, id: id, ref: containerRef, children: (0, jsx_runtime_1.jsx)(Container_1.default, { withContentPadding: withContentPadding, fluid: "md", className: popup_module_scss_1.default.contentContainer, children: children }) }), actions && ((0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, Object.assign({ variants: variants.actions, transition: transitionsProps.actions, className: (0, classnames_1.default)(popup_module_scss_1.default.actions, popup_module_scss_1.default[`variant_${variant}`]) }, baseMotionProps, { children: actions })))] })) }) })) }) }));
});
exports.default = Popup;
/**
 * This hook adds/removes the `popup-open` class to the body element to hide the scrollbar
 */
function useHideScrollbar(isOpen) {
    (0, react_1.useEffect)(() => {
        document.body.classList[isOpen ? 'add' : 'remove']('popup-open');
        return () => document.body.classList.remove('popup-open');
    }, [isOpen]);
}
const variants = {
    modal: {
        hidden: {
            opacity: 0,
            transition: {
                when: 'afterChildren',
            },
        },
        visible: {
            opacity: 1,
            transition: {
                when: 'beforeChildren',
            },
        },
    },
    content: {
        hidden: { y: '-30%', opacity: 0 },
        visible: { y: 0, opacity: 1 },
    },
    actions: {
        hidden: { y: '30%', opacity: 0 },
        visible: { y: 0, opacity: 1 },
    },
};
const baseMotionProps = {
    initial: 'hidden',
    animate: 'visible',
    exit: 'hidden',
};
const transitionsProps = {
    modal: {
        duration: 0.1,
        ease: 'easeInOut',
    },
    content: {
        duration: 0.2,
        ease: 'easeInOut',
    },
    actions: {
        duration: 0.4,
        ease: 'easeInOut',
    },
};
